<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div v-loading="loadingForm" style="height: calc(100vh - 160px);">
            <form action="#" id="addform" class="h-100">
                <div class="h-100">
                    <div class="card p-4 pt-0 h-100" style="box-shadow: none;">
                        <div class="text-end p-2 d-flex justify-content-between align-items-center">
                            <!-- 中英文切换 -->
                            <div>
                                <el-radio-group v-model="currentTab" size="" @change="changeLang">
                                    <el-radio-button :label="getLangValue('base.chinese')" value="1" />
                                    <el-radio-button :label="getLangValue('base.english')" value="2" />
                                </el-radio-group>
                            </div>
                            <div>
                                <b-button variant="light" class="waves-effect waves-light me-4"
                                    @click="handlerCancel()">{{
                                        getLangValue("base.cancel") }}</b-button>
                                <b-button v-permit="['hscode.modify', 'hscode.add']"
                                    style="background-color: #0AB39C;color:white" class="btn-success"
                                    @click="handlerSubmit()">{{
                                        getLangValue("base.done")
                                    }}</b-button>
                            </div>
                        </div>
                        <div class="my-scroll-bar" style="height: calc(100% - 60px); overflow-y: auto;">
                            <b-card>
                                <div class="row gy-3 w-100 mt-2">
                                    <div
                                        style="font-weight: bold;border-bottom: 1px solid #E9EBEC; margin: 10px 0;font-size: 16px;">
                                        {{
                                            currentTab == 1 ? getLangValueByKey("hscode.parentclassencoding") :
                                                getLangValueByKey("hscode.parentclassencoding", 'en') }}</div>
                                    <div class="col-3">
                                        <label class="form-label">
                                            <!-- <span class="text-danger">*</span> -->
                                            <span>{{ currentTab == 1 ? getLangValueByKey("hscode.encodingtype") :
                                                getLangValueByKey("hscode.encodingtype", 'en') }}</span>
                                        </label>
                                        <!-- <input type="text" class="form-control" v-model="formData.type" :class="[
                                ((isCheckForm && (!formData.type))) &&
                                'is-invalid',
                            ]" required /> -->
                                        <!-- <Multiselect id="garment" class="form-control" v-model="formData.type" label="title"
                                value-prop="id" :close-on-select="true" :searchable="true" :create-option="false"
                                :options="typeList" /> -->
                                        <div style="height: 37.5px;" class="my-cascader">
                                            <el-cascader v-model="formData.type" ref="typeRef"
                                                style="width: 100%; height: 100%;" @change="changeType"
                                                :options="typeList" :disabled="$route.query.id" :props="props1"
                                                placeholder=" " clearable :class="[
                                                    (isCheckForm && !formData.type.length) &&
                                                    'is-invalid',
                                                ]" />
                                        </div>
                                    </div>
                                    <!-- <div class="col-3">
                                    <label  class="form-label">
                                        <span class="text-danger">*</span>
                                        <span>{{ getLangValue("hscode.dataBase") }}</span>
                                    </label>
                                    <div>
                                        <el-select id="dataBase" :disabled="$route.query.id" v-model="formData.dataBase"
                                            placeholder=" " size="large" style="width: 100%" clearable :class="[
                                                ((isCheckForm && ((!this.formData.type.length || this.formData.type[0] == '') && !formData.dataBase))) &&
                                                'is-invalid',
                                            ]">
                                            <el-option v-for="item in dataBaseList" :key="item.key" :label="item.name"
                                                :value="item.key" />
                                        </el-select>
                                    </div>
                                </div> -->
                                </div>
                            </b-card>
                            <b-card>
                                <div class="row gy-3 w-100 mt-2">
                                    <div
                                        style="font-weight: bold;border-bottom: 1px solid #E9EBEC; margin: 10px 0; font-size: 16px;">
                                        {{
                                            currentTab == 1 ? getLangValueByKey("attribute.base") :
                                                getLangValueByKey("attribute.base", 'en') }}</div>
                                    <div class="col-2">
                                        <label class="form-label">
                                            <span class="text-danger1">*</span>
                                            <span>{{ showMarket ? (currentTab == 1 ?
                                                getLangValueByKey("hscode.target_market") :
                                                getLangValueByKey('hscode.target_market', 'en')) : name }}</span>
                                        </label>
                                        <!-- && !checkNumber() -->
                                        <input clearable :type="showType" class="form-control" :max-length="textlength"
                                            v-model="formData.name" :class="[
                                                isCheckForm && (!formData.name) &&
                                                'is-invalid',
                                            ]" @blur="blurName" required v-show="currentTab == 1" />
                                        <input clearable :type="showType" class="form-control" :max-length="textlength"
                                            v-model="formData.name_en" :class="[
                                                isCheckForm && (!formData.name_en) &&
                                                'is-invalid',
                                            ]" @blur="blurName" required v-show="currentTab == 2" />
                                        <div id="passwordHelpBlock" class="form-text">
                                            {{ message }}
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <label for="description" class="form-label">
                                            <!-- <span class="text-danger">*</span> -->
                                            <span>{{ currentTab == 1 ? getLangValueByKey("attribute.description") :
                                                getLangValueByKey("attribute.description", 'en') }}</span>
                                        </label>
                                        <textarea id="description" style="height: 37.5px;" type="text"
                                            class="form-control" v-model="formData.description" required
                                            v-show="currentTab == 1" />
                                        <textarea id="description" style="height: 37.5px;" type="text"
                                            class="form-control" v-model="formData.description_en" required
                                            v-show="currentTab == 2" />
                                        <span
                                            v-show="formData.description.length > 500 || formData.description_en.length > 500"
                                            style="color:red">{{ currentTab == 1 ?
                                                getLangValueByKey("hscode.descriptionLong") :
                                                getLangValueByKey("hscode.descriptionLong", 'en') }}</span>
                                    </div>
                                    <div class="col-2" v-if="requiredCode">
                                        <label for="description" class="form-label">
                                            <span class="text-danger">*</span>
                                            <span>{{ currentTab == 1 ? getLangValueByKey("hscode.productCode")
                                                : getLangValueByKey("hscode.productCode", 'en') }}</span>
                                        </label>
                                        <input clearable type="text" class="form-control" v-model="formData.code"
                                            :class="[
                                                isCheckForm && (!formData.code && requiredCode) &&
                                                'is-invalid',
                                            ]" />
                                    </div>
                                    <!-- 2024-10-12 新增目的市场-->
                                    <!-- <div class="col-2" v-if="this.currentLevel >= 3">
                                    <label for="description" class="form-label">
                                        <span>{{ getLangValue("hscode.target_market") }}
                                            <i id="target_market" class="ri-question-line" @mouseover="mouseOver(0)"
                                                @mouseleave="mouseLeave($event, 0)"></i>
                                            <b-popover target="target_market" v-model:show="showReference" triggers="">
                                                <div ref="reference_target_market" style="min-width: 200px;"
                                                    @mouseleave="showReference = false">
                                                    <div>{{ getLangValue("hscode.target_market_description") }}</div>
                                                </div>
                                            </b-popover>
                                        </span>
                                    </label>
                                    <Multiselect id="country" class="form-control" label="zh" value-prop="key"
                                        :close-on-select="true" :searchable="true" :create-option="false"
                                        @change="changeCountry" v-model="target_market" :options="countryList" />
                                </div>
                                <div class="col-2" v-if="this.currentLevel >= 3">
                                    <label for="description" class="form-label" v-show="target_market == 'other'">
                                        <span>
                                            {{ getLangValue("hscode.target_market_code") }}
                                            <i id="target_market_code" class="ri-question-line"
                                                @mouseover="mouseOver(1)" @mouseleave="mouseLeave($event, 1)"></i>
                                            <b-popover target="target_market_code" v-model:show="showReference1"
                                                triggers="">
                                                <div ref="reference_target_market_code" style="min-width: 200px;"
                                                    @mouseleave="showReference1 = false">
                                                    <div>{{ getLangValue("hscode.target_market_code_description") }}</div>
                                                </div>
                                            </b-popover>
                                        </span>
                                    </label>
                                    <input clearable type="text" class="form-control" v-show="target_market == 'other'"
                                        v-model="formData.target_market_code" />
                                </div> -->
                                </div>
                            </b-card>
                            <b-card>
                                <div class="row gy-3 w-100 mt-2">
                                    <div
                                        style="font-weight: bold;border-bottom: 1px solid #E9EBEC; margin: 10px 0;font-size: 16px;">
                                        {{ currentTab == 1 ? getLangValueByKey("attribute.indicatorstandards") :
                                            getLangValueByKey("attribute.indicatorstandards", 'en') }}</div>
                                    <!-- @onAddgroupindicator="addGroupindicator"
                                    @onDeleteGroupindicator="deleteGroupindicator" @onDeleteGroup="deleteGroup"
                                    @onAddGroupLevel1="addGroupLevel1" @onDeleteGroupLevel1="deleteGroupLevel1" -->
                                    <groupCom :isCheckForm="isCheckForm" ref="myGroupComRef"
                                        v-model:groupInfoList="groupInfoList" @showInfo="showInfo"
                                        :currentTab="currentTab" />
                                    <div class="col-3">
                                        <button type="button" class="btn btn-primary me-3"
                                            style="background-color: #0AB39C;border: unset;" @click="addGroupLevel1">{{
                                                currentTab == 1 ? getLangValueByKey("attribute.addGroup") :
                                                    getLangValueByKey("attribute.addGroup", 'en') }}</button>
                                    </div>
                                </div>
                            </b-card>
                            <b-card>
                                <div class="row gy-3 w-100 mt-2">
                                    <div
                                        style="font-weight: bold;border-bottom: 1px solid #E9EBEC; margin: 10px 0;font-size: 16px;">
                                        {{ currentTab == 1 ? getLangValueByKey("attribute.database") :
                                            getLangValueByKey("attribute.database", 'en') }}</div>
                                    <div class="col-12">
                                        <label class="form-label">
                                            <span class="text-danger1"></span>
                                            <span>{{ currentTab == 1 ? getLangValueByKey("attribute.uploadMessage") :
                                                getLangValueByKey("attribute.uploadMessage", 'en') }}</span>
                                        </label>
                                        <DropZone1
                                            :accept="'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.mp4,.mov'"
                                            @drop.prevent="drop" @change.prevent="selectedFile()"
                                            :title="currentTab == 1 ? getLangValueByKey('upload.title1') : getLangValueByKey('upload.title1', 'en')"
                                            :currentTab="currentTab" style="min-height: 220px" limit="50M" />
                                    </div>
                                </div>
                            </b-card>
                            <b-card>
                                <div class="row gy-3 w-100 mt-2">
                                    <div style="font-weight: bold;font-size: 16px;">{{
                                        currentTab == 1 ? getLangValueByKey("attribute.uploadMessage") :
                                            getLangValueByKey("attribute.uploadMessage", 'en') }}
                                    </div>
                                    <div class=" border-solid rounded p-3" v-show="fileListObj.image.length">
                                        <div>
                                            <div class="border-primary fs-14 material-title">{{
                                                currentTab == 1 ? getLangValueByKey("attribute.picture") :
                                                    getLangValueByKey("attribute.picture", 'en')
                                            }}
                                            </div>
                                        </div>
                                        <div class="product-img-slider  ps-5 pe-5">
                                            <SwiperTool :swiperInfo="{
                                                type: 'image',
                                                page: 'assetform',
                                                spaceBetween: 10,
                                                slidesPerView: 15,
                                                actionsClass: [
                                                    { name: 'ri-eye-fill', action: 'view' },
                                                    { name: 'ri-download-2-fill', action: 'download' },
                                                    { name: 'ri-delete-bin-5-fill', action: 'delete' },
                                                ],
                                            }" :list="fileListObj.image" @deleteFile="deleteFile">
                                            </SwiperTool>
                                        </div>
                                    </div>
                                    <div class=" border-solid rounded p-3" v-show="fileListObj.document.length">
                                        <div>
                                            <div class="border-primary fs-14 material-title">{{
                                                currentTab == 1 ? getLangValueByKey("attribute.document") :
                                                    getLangValueByKey("attribute.document", 'en')
                                            }}
                                            </div>
                                        </div>
                                        <div class="product-img-slider  ps-5 pe-5">
                                            <SwiperTool :swiperInfo="{
                                                type: 'document',
                                                page: 'assetform',
                                                spaceBetween: 10,
                                                slidesPerView: 15,
                                                actionsClass: [
                                                    { name: 'ri-eye-fill', action: 'view' },
                                                    { name: 'ri-download-2-fill', action: 'download' },
                                                    { name: 'ri-delete-bin-5-fill', action: 'delete' },
                                                ],
                                            }" :list="fileListObj.document" @deleteFile="deleteFile">
                                            </SwiperTool>
                                        </div>
                                    </div>
                                    <div class=" border-solid rounded p-3" v-show="fileListObj.video.length">
                                        <div>
                                            <div class="border-primary fs-14 material-title">{{
                                                currentTab == 1 ? getLangValueByKey("attribute.video") :
                                                    getLangValueByKey("attribute.video", 'en') }}
                                            </div>
                                        </div>
                                        <div class="product-img-slider  ps-5 pe-5">
                                            <SwiperTool :swiperInfo="{
                                                type: 'video',
                                                page: 'assetform',
                                                spaceBetween: 10,
                                                slidesPerView: 15,
                                                actionsClass: [
                                                    { name: 'ri-eye-fill', action: 'view' },
                                                    { name: 'ri-download-2-fill', action: 'download' },
                                                    { name: 'ri-delete-bin-5-fill', action: 'delete' },
                                                ],
                                            }" :list="fileListObj.video" @deleteFile="deleteFile">
                                            </SwiperTool>
                                        </div>
                                    </div>

                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </form>
            <!-- <div class="card mb-0" style="box-shadow: none;">
        </div> -->
        </div>
        <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
    </Layout>
</template>

<script>
import { uploadFile, postHscode, getHscodeDetail, getHscodeDataBase, getHscode, putHscode } from "@/service";
import SwiperTool from "@/components/swiperTool.vue";
import groupCom from "./components/group_new"
const fileMaxSize = 1024 * 1024 * 50;
import i18n from "@/i18n"
// import Swal from "sweetalert2";
import { getParentIds } from "@/utils/common"
import { nextTick } from "vue";
import _ from "lodash";
// import countryList from "@/utils/country.js"
import { getLangValue, getLangValueByKey, highlightText } from "@/utils/common"; //获取后端语言
export default {
    components: {
        SwiperTool,
        groupCom,
    },
    data() {
        return {
            i18n,
            PageHeaderT: `${getLangValue("hscode.detailTitle")}`,
            PageHeaderItems: [
                {
                    text: getLangValue("hscode.detailTitle"),
                    active: true,
                    href: "/hscode_management_detail",
                },
                {
                    text: `${this.$route.query.type == "add" ? getLangValue("hscode.add") : getLangValue("hscode.edit")}`,
                    active: true,
                    href: "",
                },
            ],
            formData: {
                type: [],
                name: '',
                name_en: '',
                description: '',
                description_en: '',
                dataBase: '',
                code: '',
                // target_market_code: '',
            },
            // target_market: '',
            fileListObj: {
                image: [],
                video: [],
                document: [],
            },
            alertInfo: {
                variant: "danger",
                content: "",
                icon: "ri-error-warning-line",
            },
            formValidataAlert: false,
            isCheckForm: false,
            groupInfoList: [],
            typeList: [], //编码分类list
            dataBaseList: [],
            props1: {
                label: i18n.global.locale == 'en' ? 'title_en' : 'title',
                value: 'id',
                children: 'children',
                checkStrictly: true,
            },
            loadingForm: false,
            message: '',
            showType: 'text',
            textlength: '',
            name: getLangValue("hscode.encodingName"),
            requiredCode: false,
            fatherinstandList: [],
            // countryList: countryList,
            showReference: false,
            showReference1: false,
            currentLevel: 0,
            showMarket: false,
            currentTab: i18n.global.locale == 'en' ? 2 : 1,
            langData: {
                en: {},
                ch: {},
            }
        };
    },
    methods: {
        // mouseOver(i) {
        //     i > 0 ? this.showReference1 = true : this.showReference = true;
        // },
        // mouseLeave(event, i) {
        //     // 获取鼠标离开时的元素
        //     let relatedTarget = event.relatedTarget;
        //     if (relatedTarget && relatedTarget.className == "popover-arrow") {
        //         return;
        //     }
        //     i > 0 ? this.showReference1 = false : this.showReference = false;
        // },
        // changeCountry(val) {
        //     // console.log(val, odlVal);
        //     // console.log(this.target_market);
        //     this.target_market = val
        //     if (this.target_market == "" || this.target_market == null) {
        //         this.formData.target_market_code = ""
        //         return
        //     }
        //     let arr = this.countryList.filter(item => item.key == this.target_market)
        //     this.formData.target_market_code = arr[0].key
        // },
        highlightText,
        getLangValue,
        getLangValueByKey,
        changeLang(val) {
            //语言切换
            console.log(val);
            this.props1.label = val == 2 ? 'title_en' : 'title';
            this.name = val == 2 ? getLangValueByKey("hscode.encodingName", 'en') : getLangValueByKey("hscode.encodingName");
            if (val == 2) {
                // 原来是中文
                // 表单
                this.formData.name_en = this.formData.name_en || this.formData.name;
                this.formData.description_en = this.formData.description_en || this.formData.description;
            } else {
                // 原来是英文
                // 表单
                this.formData.name = this.formData.name || this.formData.name_en;
                this.formData.description = this.formData.description || this.formData.description_en;
            }
            // 指标信息
            this.setGroupInfo(val)
        },
        setGroupInfo(val) {
            // 当填写某一种语言的信息后  填充到另一个语言里面
            for (const item in this.groupInfoList) {
                const { group_name, group_name_en, children, indicatorList } = this.groupInfoList[item];
                if (val == 2) {
                    // 原来是中文
                    let group_name_en_new = group_name_en || group_name;
                    this.groupInfoList[item].group_name_en = group_name_en_new;
                    // 指标标准信息
                    for (const i in indicatorList) {
                        const { name, name_en, unit, unit_en, reference, reference_en } = indicatorList[i]
                        let name_en_new = name_en || name;
                        let unit_en_new = unit_en || unit;
                        let reference_en_new = reference_en || reference;
                        indicatorList[i].name_en = name_en_new;
                        indicatorList[i].unit_en = unit_en_new;
                        indicatorList[i].reference_en = reference_en_new;
                    }
                    //子集
                    if (children.length) {
                        for (const child_1 in children) {
                            const { group_name: groupName1, group_name_en: groupName_en1, children: children1, indicatorList: indicatorList1 } = children[child_1]
                            let groupName_en1_new = groupName_en1 || groupName1;
                            children[child_1].group_name_en = groupName_en1_new;
                            for (const i in indicatorList1) {
                                const { name, name_en, unit, unit_en, reference, reference_en } = indicatorList1[i]
                                let name_en_new = name_en || name;
                                let unit_en_new = unit_en || unit;
                                let reference_en_new = reference_en || reference;
                                indicatorList1[i].name_en = name_en_new
                                indicatorList1[i].unit_en = unit_en_new
                                indicatorList1[i].reference_en = reference_en_new
                            }
                            //子集
                            if (children1) {
                                for (const child_2 in children1) {
                                    const { group_name: groupName2, group_name_en: groupName_en2, indicatorList: indicatorList2 } = children1[child_2]
                                    let groupName_en2_new = groupName_en2 || groupName2;
                                    children1[child_2].group_name_en = groupName_en2_new;
                                    for (const i in indicatorList2) {
                                        const { name, name_en, unit, unit_en, reference, reference_en } = indicatorList2[i]
                                        let name_en_new = name_en || name;
                                        let unit_en_new = unit_en || unit;
                                        let reference_en_new = reference_en || reference;
                                        indicatorList2[i].name_en = name_en_new
                                        indicatorList2[i].unit_en = unit_en_new
                                        indicatorList2[i].reference_en = reference_en_new
                                    }

                                }
                            }
                        }
                    }
                } else {
                    // 原来是英文
                    let group_name_new = group_name || group_name_en;
                    this.groupInfoList[item].group_name = group_name_new;
                    // 指标标准信息
                    for (const i in indicatorList) {
                        const { name, name_en, unit, unit_en, reference, reference_en } = indicatorList[i]
                        let name_new = name || name_en;
                        let unit_new = unit || unit_en;
                        let reference_new = reference || reference_en;
                        indicatorList[i].name = name_new;
                        indicatorList[i].unit = unit_new;
                        indicatorList[i].reference = reference_new;
                    }
                    //子集
                    if (children.length) {
                        for (const child_1 in children) {
                            const { group_name: groupName1, group_name_en: groupName_en1, children: children1, indicatorList: indicatorList1 } = children[child_1]
                            let groupName_new = groupName1 || groupName_en1;
                            children[child_1].group_name = groupName_new;
                            for (const i in indicatorList1) {
                                const { name, name_en, unit, unit_en, reference, reference_en } = indicatorList1[i]
                                let name_new = name || name_en;
                                let unit_new = unit || unit_en;
                                let reference_new = reference || reference_en;
                                indicatorList1[i].name = name_new;
                                indicatorList1[i].unit = unit_new;
                                indicatorList1[i].reference = reference_new;
                            }
                            //子集
                            if (children1) {
                                for (const child_2 in children1) {
                                    const { group_name: groupName2, group_name_en: groupName_en2, indicatorList: indicatorList2 } = children1[child_2]
                                    let groupName_new = groupName2 || groupName_en2;
                                    children1[child_2].group_name = groupName_new;
                                    for (const i in indicatorList2) {
                                        const { name, name_en, unit, unit_en, reference, reference_en } = indicatorList2[i]
                                        let name_new = name || name_en;
                                        let unit_new = unit || unit_en;
                                        let reference_new = reference || reference_en;
                                        indicatorList2[i].name = name_new;
                                        indicatorList2[i].unit = unit_new;
                                        indicatorList2[i].reference = reference_new;
                                    }

                                }
                            }
                        }
                    }
                }
            }
            console.log(this.groupInfoList);
        },
        async changeType() {
            // 切换父级编码类型 选中父亲类型的databse
            const node = this.$refs.typeRef.getCheckedNodes().length ? this.$refs.typeRef.getCheckedNodes()[0] : "";
            // console.log(node);
            // if (node && node.data.database) {
            //     this.formData.dataBase = node.data.database
            //     return
            // }
            // if (!node.pathLabels) {
            //     this.formData.dataBase = "";
            //     return
            // }
            // if (node.pathLabels.length) {
            //     let name = node.pathLabels[0];
            //     let arr = this.dataBaseList.filter(item => item.name.indexOf(name) > -1)
            //     if (arr.length) {
            //         this.formData.dataBase = arr[0].key;
            //     }
            // }
            // this.formData.dataBase = ""
            // 1级 不等于无 则需要 4位数字  2级 不等于无 则需要 6位数字  无则anything
            // 2024-7-17逻辑修改 当编码分类为“无”时，基本信息中编码名称提示信息“请填写产品大类的名称”；
            // 当编码分类为“服装/2位编码/4位编码/。。。“时，基本信息中编码名称提示信息”请填写”服装/2位编码/4位编码/。。。“的子项编码
            this.currentLevel = node.level
            // console.log(this.currentLevel);
            console.log(node);
            if (!node.text) {
                this.message = ''
                this.formData.type = []
                this.textlength = ""
                this.showType = ''
                this.requiredCode = false

            } else {
                if (node.level == 1) {
                    this.message = node.text == getLangValueByKey("base.none") || node.text == getLangValueByKey("base.none", 'en') ? getLangValue("hscode.message2") : `${this.getLangValue('hscode.fill')} ${node.text} ${this.getLangValue('hscode.target_market')}`;
                    this.showType = 'text'
                    // this.textlength = node.text == getLangValue("base.none") ? '' : 4;
                    // this.name = node.text == getLangValue("base.none") ? this.getLangValue("attribute.name") : getLangValue("hscode.hsCodeFourLength")
                    this.showMarket = node.text == getLangValueByKey("base.none") || node.text == getLangValueByKey("base.none", 'en') ? false : true;
                } else {
                    this.message = `${this.getLangValue('hscode.fill')} ${node.text} ${this.getLangValue('hscode.subItemCode')}`
                    this.showType = 'number'
                    this.showMarket = false;
                    this.textlength = node.level == 2 ? 2 : ''
                    // this.name = getLangValue("hscode.hsCodeSixLength")
                    console.log(node.level);
                    // 如果formData.name不是数字 则清空
                    if (!/^\d+$/.test(this.formData.name)) {
                        this.formData.name = ''
                    }
                    if (!/^\d+$/.test(this.formData.name_en)) {
                        this.formData.name_en = ''
                    }
                }
                if (node.text == getLangValueByKey("base.none") || node.text == getLangValueByKey("base.none", 'en')) {
                    this.addGroupLevel1()
                    this.requiredCode = true
                } else {
                    this.requiredCode = false
                }
            }

            if (node.text == getLangValueByKey("base.none") || node.text == getLangValueByKey("base.none", 'en')) {
                this.groupInfoList = []
                //添加默认的三级指标信息    
                this.addGroupLevel1()
            }
            // 获取父级情信息
            // console.log(node.data.id);
            if (node.data && node.data.id && this.$route.query.type != 'edit') {
                const resp = await getHscodeDetail(node.data.id)
                //获取hscode详细信息
                if (resp) {
                    if (Object.keys(resp.payload.index_standards).length) {
                        // 展示父级的数据
                        // for (let k in resp.payload.index_standards) {
                        //     let arr = resp.payload.index_standards[k].map(item => {
                        //         item.add = false
                        //         return item
                        //     })
                        //     let groupInfo = {
                        //         groupName: k,
                        //         category_name: arr[0].category_name !== '' && arr[0].category_name != null ? arr[0].category_name : '', // 新增指标类别
                        //         indicatorList: arr,
                        //     };
                        //     this.groupInfoList.push(groupInfo);
                        // }
                        this.set_index_standards(resp.payload.index_standards, 'add')
                    }

                }
            }


        },
        checkNumber() {
            if (this.showType == 'number') {
                if (this.formData.name.length != this.textlength) {
                    return false
                }
            }
            return true
        },
        blurName() {
            if (!this.textlength) return false
            if (this.formData.name.length > this.textlength) {
                this.formData.name = this.formData.name.slice(0, this.textlength)
            }
            if (this.formData.name_en.length > this.textlength) {
                this.formData.name_en = this.formData.name_en.slice(0, this.textlength)
            }
        },
        async getDataBaseList() {
            /**获取数据库列表 */
            const resp = await getHscodeDataBase();
            if (resp) {
                this.dataBaseList = resp.payload;
            }
        },

        flattenTree1(tree) {
            let level = 1
            tree.forEach(item => {
                item.level = level
                // if (item.children && item.children.length > 0 && level <= 3) {
                //     // level++
                //     this.flattenTree1(item.children, level++)
                // } else {
                //     item.children = []
                // }
            })

        },
        flattenTree(tree) {
            //遍历树 获取前2层结构
            // 2024-7-17 获取前4层机构
            // tree.map(node => {
            //     if (node.children && node.children.length > 0) {
            //         const { children } = node
            //         children.forEach(child => {
            //             child.children = [];
            //         })
            //     }
            //     return node
            // });
            tree.forEach((treeData) => {
                treeData.num = 1;
                if (treeData.children && treeData.children.length) {
                    treeData.children = this.setValue(treeData.children, treeData.num);
                }
            });
            // console.log(tree);
            // 增加一个无的选择
            tree.push(
                {
                    title: getLangValueByKey("base.none"),
                    title_en: getLangValueByKey("base.none", 'en'),
                    id: '',
                }
            );
            return tree;
        },
        async getTypeList() {
            /***获取编码分类  应该有父级的 */
            const resp = await getHscode();
            if (resp) {
                if (this.$route.query.id) {
                    // let res = []
                    // findParent(resp.payload, this.$route.query.id, res)
                    // // console.log(res)
                    // res.pop();
                    // //回显type
                    // this.formData.type = res.length ? res.map(item => item) : [""]
                    nextTick(() => {
                        this.changeType()
                    })
                }
                if (this.$route.query.parentId) {
                    // let res = []
                    // findParent(resp.payload, this.$route.query.parentId, res)
                    // // console.log(res)
                    // // res.pop();
                    // //回显type
                    // this.formData.type = res.length ? res.map(item => item) : [""];
                    nextTick(() => {
                        this.changeType()
                    })

                }
                this.typeList = this.flattenTree(resp.payload);
                if (!this.$route.query.type) {
                    this.$router.push({ name: 'hscode_management_detail', query: { type: 'add' }, })
                } else {
                    const { type, id } = this.$route.query;
                    if (type == 'edit' && id) {
                        // 根据id获取信息
                        this.getHscodeInfoByid(id)
                    }
                }
            }
        },
        handlerCancel() {
            //取消 返回管理页
            // this.$router.go(-1)
            const { showIndex } = this.$route.query;
            this.$router.push({ name: 'hscode_management', query: { showIndex: showIndex ? showIndex : '' } })
        },
        addGroupLevel1() {
            //添加指标分类
            let groupInfo = {
                add: true,
                category_name: '', // 新增指标类别
                group_name: '', // 新增指标类别描述
                group_name_en: '',
                indicatorList: [], //指标
                expand: true, // 默认展开
                children: [
                    {
                        add: true,
                        group_name: '',
                        group_name_en: '',
                        indicatorList: [], //指标
                        canedit: true,
                        children: [
                            {
                                add: true,
                                group_name: '',
                                group_name_en: '',
                                canedit: true,
                                indicatorList: [
                                    {
                                        add: true,
                                        name: '',
                                        name_en: '',
                                        unit: '',
                                        unit_en: '',
                                        value: '',
                                        reference: '',
                                        reference_en: '',
                                        threshold: '',
                                        judgement_model: '',
                                        is_applicable: '0',
                                        is_specific: '0',
                                        calculation_mode: '',
                                    }
                                ],
                            },
                        ]
                    },
                ]

            };
            this.groupInfoList.push(groupInfo)
        },
        addGroup() {
            //添加组
            let groupInfo = {
                add: true,
                groupName: '',
                groupName_en: '',
                category_name: '', // 新增指标类别
                indicatorList: [
                    {
                        add: true,
                        name: '',
                        name_en: '',
                        unit: '',
                        unit_en: '',
                        value: '',
                        reference: '',
                        reference_en: '',
                    }
                ],
            };
            this.groupInfoList.push(groupInfo)
        },
        makeGroupList() {
            // 处理指标数据
            let groupList = []
            let extra = {
                groupList1: [],
                groupList2: [],
                groupList3: [],
            }
            for (const item in this.groupInfoList) {
                // 第一级
                const { group_name, group_name_en, category_name, indicatorList, children } = this.groupInfoList[item]
                extra.groupList1.push(group_name)
                let m = {
                    group_path: '',
                    group_name: group_name,
                    group_name_en: group_name_en,
                    category_name: category_name,
                }
                if (indicatorList) {
                    //去掉筛选
                    // .filter(item => item.add || item.canedit)
                    indicatorList.forEach(item_indicator => {
                        let info = {
                            ...item_indicator,
                            ...m
                        }
                        info.is_applicable = info.is_applicable == 1 ? true : false;
                        info.is_specific = info.is_specific == 1 ? true : false;
                        info.threshold = info.threshold == null || info.threshold == 'null' ? '' : info.threshold + ''
                        // 如果judemode ==[]
                        if (item_indicator.judgement_model == '[]') {
                            // threshold 为数组
                            info.threshold = JSON.stringify([item_indicator.threshold1, item_indicator.threshold2])
                        }
                        groupList.push(info)
                    })
                }
                // 第二级数据
                if (children.length) {
                    for (const item1 in children) {
                        const { group_name: group_name1, group_name_en: group_name_en1, indicatorList: indicatorList1, children: children1 } = children[item1]
                        extra.groupList2.push(group_name1)
                        if (indicatorList) {
                            let m = {
                                group_path: [group_name],
                                group_path_en: [group_name_en],
                                group_name: group_name1,
                                group_name_en: group_name_en1,
                                category_name: category_name,
                            }
                            // .filter(item => item.add || item.canedit)
                            indicatorList1.forEach(item_indicator => {
                                let info = {
                                    ...item_indicator,
                                    ...m
                                }
                                info.threshold = info.threshold == null || info.threshold == 'null' ? '' : info.threshold + ''
                                // 如果judemode ==[]
                                if (item_indicator.judgement_model == '[]') {
                                    // threshold 为数组
                                    info.threshold = JSON.stringify([item_indicator.threshold1, item_indicator.threshold2])
                                }
                                info.is_applicable = info.is_applicable == 1 ? true : false;
                                info.is_specific = info.is_specific == 1 ? true : false;
                                groupList.push(info)
                            })
                        }
                        // 第三级数据
                        if (children1.length) {
                            for (const item2 in children1) {
                                const { group_name: group_name2, group_name_en: group_name_en2, indicatorList: indicatorList2, } = children1[item2]
                                extra.groupList3.push(group_name2)
                                if (indicatorList2) {
                                    let m = {
                                        group_path: [group_name, group_name1],
                                        group_path_en: [group_name_en, group_name_en1],
                                        group_name: group_name2,
                                        group_name_en: group_name_en2,
                                        category_name: category_name,
                                    }
                                    //.filter(item => item.add || item.canedit)
                                    indicatorList2.forEach(item_indicator => {
                                        let info = {
                                            ...item_indicator,
                                            ...m
                                        }
                                        info.threshold = info.threshold == null || info.threshold == 'null' ? '' : info.threshold + ''
                                        // 如果judemode ==[]
                                        if (item_indicator.judgement_model == '[]') {
                                            // threshold 为数组
                                            info.threshold = JSON.stringify([item_indicator.threshold1, item_indicator.threshold2])
                                        }
                                        // console.log(info);
                                        info.is_applicable = info.is_applicable == 1 ? true : false;
                                        info.is_specific = info.is_specific == 1 ? true : false;

                                        groupList.push(info)
                                    })
                                }
                            }
                        }
                    }
                }
            }
            if (groupList.length) {
                groupList[0].extra = extra
            }
            return groupList
        },
        async handlerSubmit() {
            //保存hscode
            if (this.checkForm()) {
                // 处理组 指标
                let groupList = this.makeGroupList();
                console.log(groupList);
                //处理图片
                let fileList = []
                for (let k in this.fileListObj) {
                    if (this.fileListObj[k].length) {
                        let idList = this.fileListObj[k].map(item => item.id)
                        fileList = [...fileList, ...idList]
                    }
                }
                let arr = [...this.formData.type]
                let xx = true
                console.log(this.formData.name);
                console.log(this.formData.name_en);
                if (xx) {
                    let params = {
                        // id:this.$route.query.id? this.$route.query.id: '',
                        // database: this.formData.dataBase,
                        parent_id: arr.length ? arr.pop() : "",
                        title: this.formData.name + '',
                        title_en: this.formData.name_en + '',
                        description: this.formData.description,
                        description_en: this.formData.description_en,
                        code: this.formData.code,
                        // destination_market: '',
                        index_standards: JSON.stringify(groupList),
                        attachments: fileList.length ? JSON.stringify(fileList) : null,
                    };
                    // if (this.currentLevel >= 3) {
                    //     params.destination_market = this.formData.target_market_code ? this.formData.target_market_code : '-'
                    // }
                    if (this.$route.query.id) {
                        let id = this.$route.query.id
                        const resp = await putHscode(id, params)
                        if (resp) {
                            // Swal.fire({
                            //     title: i18n.global.t("base.alert_message_info"),
                            //     text: resp.message,
                            //     icon: 'info',
                            // })
                            this.openAlert({
                                variant: resp.code == 1 ? "danger" : 'success',
                                content: resp.code == 1 ? resp.message : this.getLangValue("base.edit_success"),
                                icon: "ri-alert-line",
                            });
                            if (resp.code !== 1)
                                setTimeout(async () => {
                                    this.$router.push({
                                        name: 'hscode_management', query: {
                                            id: resp.payload.id, showIndex: this.$route.query.showIndex ?
                                                this.$route.query.showIndex : ''
                                        }
                                    })
                                }, 1000)
                        }
                    } else {
                        const resp = await postHscode(params)
                        if (resp) {
                            // Swal.fire({
                            //     title: i18n.global.t("base.alert_message_info"),
                            //     text: resp.message,
                            //     icon: 'info',
                            // })
                            this.openAlert({
                                variant: resp.code == 1 ? "danger" : 'success',
                                content: resp.code == 1 ? resp.message : this.getLangValue("base.add_success"),
                                icon: "ri-alert-line",
                            });
                            // 传递id 选中
                            if (resp.code !== 1)
                                setTimeout(async () => {
                                    this.$router.push({
                                        name: 'hscode_management', query: {
                                            id: resp.payload.id, showIndex: this.$route.query.showIndex ?
                                                this.$route.query.showIndex : ''
                                        }
                                    })
                                }, 1000)

                        }
                    }
                }

            } else {
                nextTick(() => {
                    // 定位到必填的元素
                    const elements = document.getElementsByClassName('is-invalid');
                    if (elements.length) {
                        elements[0].scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                })

            }
        },
        showInfo(type) {
            if (type == 0) {
                this.openAlert({
                    content: getLangValue("hscode.sameGroupName"),
                    icon: "ri-error-warning-line",
                    variant: "danger",
                });
            } else if (type == 1) {
                this.openAlert({
                    content: getLangValue("hscode.sameSubGroupName"),
                    icon: "ri-error-warning-line",
                    variant: "danger",
                });
            } else if (type == 2) {
                this.openAlert({
                    content: getLangValue("hscode.same_category_name"),
                    icon: "ri-error-warning-line",
                    variant: "danger",
                });
            } else if (type == 4) {
                this.openAlert({
                    content: getLangValue("hscode.same_group_subGroup_name"),
                    icon: "ri-error-warning-line",
                    variant: "danger",
                });
            }
            else {
                // type 3
                this.openAlert({
                    content: this.getLangValue("base.sameIndicator"),
                    icon: "ri-error-warning-line",
                    variant: "danger",
                });
            }

        },
        checkFormLevel1() {
            let checkRes = true;
            // 验证第一级 必填项
            if (this.$refs.myGroupComRef.repeatGroupList.length) {
                this.showInfo(2)
                checkRes = false;
                return checkRes;
            }
            // 验证组名称或子组名称是否重复
            // console.log(this.$refs.myGroupComRef.repeatGroupList1);
            if (Object.keys(this.$refs.myGroupComRef.repeatGroupList1).length) {
                for (const item in this.$refs.myGroupComRef.repeatGroupList1) {
                    if (this.$refs.myGroupComRef.repeatGroupList1[item].length) {
                        this.showInfo(4)
                        checkRes = false;
                        this.currentTab = 1;
                        return checkRes;
                    }
                }
            }
            if (Object.keys(this.$refs.myGroupComRef.repeatGroupList1_en).length) {
                for (const item in this.$refs.myGroupComRef.repeatGroupList1_en) {
                    if (this.$refs.myGroupComRef.repeatGroupList1_en[item].length) {
                        this.showInfo(4)
                        checkRes = false;
                        this.currentTab = 2;
                        return checkRes;
                    }
                }
            }
            // 如果有指标  验证指标名称是否重复
            for (let k in this.groupInfoList) {
                const { indicatorList, category_name, group_name, group_name_en, children } = this.groupInfoList[k];
                if (category_name === '' || group_name === '' || group_name_en === '') {
                    this.openAlert({
                        content: this.getLangValue("base.requireGroupAndindicator"),
                        icon: "ri-error-warning-line",
                        variant: "danger",
                    });
                    checkRes = false;
                    break;
                }
                // 验证指标名称是否重复
                if (indicatorList.length) {
                    let arr = indicatorList.map(item => item.name)
                    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
                    if (duplicates.length) {
                        checkRes = false;
                        this.currentTab = 1
                        this.showInfo(3)
                        nextTick(() => {
                            this.highlightText(duplicates[0]);
                        })
                        break;
                    }
                    // 英文指标名称重复
                    let arr_en = indicatorList.map(item => item.name_en)
                    const duplicates_en = arr_en.filter((value, index, self) => self.indexOf(value) !== index);
                    if (duplicates_en.length) {
                        checkRes = false;
                        this.showInfo(3)
                        this.currentTab = 2
                        nextTick(() => {
                            this.highlightText(duplicates_en[0]);
                        })
                        break;
                    }

                    let arr1 = indicatorList.filter(item => item.name === '')
                    if (arr1.length) {
                        checkRes = false;
                        this.openAlert({
                            content: this.getLangValue("base.requireGroupAndindicator"),
                            icon: "ri-error-warning-line",
                            variant: "danger",
                        });
                        this.currentTab = 1
                        break;
                    }
                    // 英文指标名称为空
                    let arr1_en = indicatorList.filter(item => item.name_en === '')
                    if (arr1_en.length) {
                        checkRes = false;
                        this.openAlert({
                            content: this.getLangValue("base.requireGroupAndindicator"),
                            icon: "ri-error-warning-line",
                            variant: "danger",
                        });
                        this.currentTab = 2
                        break;
                    }
                    // 验证是否适用  需要填写阈值  达标判断方式
                    // let arr_2 = indicatorList.filter(item => (category_name==3 && item.is_applicable == 1) && (item.threshold === '' || item.judgement_model === '' || item.judgement_model == null))
                    let arr_2 = []
                    if (arr_2.length) {
                        checkRes = false;
                        this.openAlert({
                            content: this.getLangValue("base.needInfo"),
                            icon: "ri-error-warning-line",
                            variant: "danger",
                        });
                        break;
                    }

                    // 验证选择为介于数据 需要填写上下限值 以及上下限值 大小判断
                    let arr_3 = indicatorList.filter(item => item.judgement_model == '[]' && ((typeof item.threshold1=='undefined' || item.threshold1 ==='' || typeof item.threshold2=='undefined'  ||!item.threshold2 ==='') || (item.threshold1 >= item.threshold2)))
                    if (arr_3.length) {
                        checkRes = false;
                        this.openAlert({
                            content: this.getLangValue("hscode.threshold_range_error"),
                            icon: "ri-error-warning-line",
                            variant: "danger",
                        });
                        break;
                    }
                }
                // 判断第二级
                if (children.length) {
                    for (const kk in children) {
                        const { indicatorList: indicatorList1, group_name: group_name1, group_name_en: group_name1_en, children: children1 } = children[kk];
                        if (group_name1 === '' || group_name1_en === '') {
                            // console.log(1111);
                            this.openAlert({
                                content: this.getLangValue("base.requireGroupAndindicator"),
                                icon: "ri-error-warning-line",
                                variant: "danger",
                            });
                            this.currentTab = group_name1 === '' ? 1 : 2;
                            checkRes = false;
                            break;
                        }
                        if (indicatorList1.length) {
                            let arr = indicatorList1.map(item => item.name)
                            const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
                            if (duplicates.length) {
                                checkRes = false;
                                this.showInfo(3)
                                this.currentTab = 1;
                                nextTick(() => {
                                    this.highlightText(duplicates[0]);
                                })
                                break;
                            }
                            // 英文指标名称重复
                            let arr_en = indicatorList1.map(item => item.name_en)
                            const duplicates_en = arr_en.filter((value, index, self) => self.indexOf(value) !== index);
                            if (duplicates_en.length) {
                                checkRes = false;
                                this.showInfo(3)
                                this.currentTab = 2
                                nextTick(() => {
                                    this.highlightText(duplicates_en[0]);
                                })
                                break;
                            }

                            let arr1 = indicatorList1.filter(item => item.name === '')
                            if (arr1.length) {
                                checkRes = false;
                                this.openAlert({
                                    content: this.getLangValue("base.requireGroupAndindicator"),
                                    icon: "ri-error-warning-line",
                                    variant: "danger",
                                });
                                this.currentTab = 1;
                                break;
                            }
                            //英文指标名称为空
                            let arr1_en = indicatorList1.filter(item => item.name_en === '')
                            if (arr1_en.length) {
                                checkRes = false;
                                this.openAlert({
                                    content: this.getLangValue("base.requireGroupAndindicator"),
                                    icon: "ri-error-warning-line",
                                    variant: "danger",
                                });
                                this.currentTab = 2;
                                break;
                            }

                            // 验证是否适用  需要填写阈值  达标判断方式
                            // let arr_2 = indicatorList1.filter(item => (category_name==3 && item.is_applicable == 1) && (item.threshold === '' || item.judgement_model === '' || item.judgement_model == null))
                            let arr_2 = []
                            if (arr_2.length) {
                                checkRes = false;
                                this.openAlert({
                                    content: this.getLangValue("base.needInfo"),
                                    icon: "ri-error-warning-line",
                                    variant: "danger",
                                });
                                break;
                            }

                            // 验证选择为介于数据 需要填写上下限值
                            let arr_3 = indicatorList1.filter(item => item.judgement_model == '[]' && ((typeof item.threshold1=='undefined' || item.threshold1 ==='' || typeof item.threshold2=='undefined'  ||!item.threshold2 ==='') || (item.threshold1 >= item.threshold2)))
                            if (arr_3.length) {
                                checkRes = false;
                                this.openAlert({
                                    content: this.getLangValue("hscode.threshold_range_error"),
                                    icon: "ri-error-warning-line",
                                    variant: "danger",
                                });
                                break;
                            }
                        }
                        if (children1.length) {
                            for (const kkk in children1) {
                                const { indicatorList: indicatorList2, group_name: group_name2, group_name_en: group_name2_en, } = children1[kkk];
                                if (group_name2 === '' || group_name2_en === '') {
                                    // console.log(111145);
                                    this.openAlert({
                                        content: this.getLangValue("base.requireGroupAndindicator"),
                                        icon: "ri-error-warning-line",
                                        variant: "danger",
                                    });
                                    this.currentTab = group_name2 === '' ? 1 : 2;
                                    checkRes = false;
                                    break;
                                }
                                if (indicatorList2.length) {
                                    let arr = indicatorList2.map(item => item.name)
                                    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
                                    if (duplicates.length) {
                                        checkRes = false;
                                        this.showInfo(3)
                                        this.currentTab = 1
                                        nextTick(() => {
                                            this.highlightText(duplicates[0]);
                                        })
                                        break;
                                    }
                                    // 英文指标名称重复
                                    let arr_en = indicatorList2.map(item => item.name_en)
                                    const duplicates_en = arr_en.filter((value, index, self) => self.indexOf(value) !== index);
                                    if (duplicates_en.length) {
                                        checkRes = false;
                                        console.log(duplicates_en);
                                        this.showInfo(3)
                                        this.currentTab = 2
                                        nextTick(() => {
                                            this.highlightText(duplicates_en[0]);
                                        })
                                        break;
                                    }

                                    let arr1 = indicatorList2.filter(item => item.name === '')
                                    // console.log(arr1);
                                    if (arr1.length) {
                                        checkRes = false;
                                        // console.log(111154);
                                        this.openAlert({
                                            content: this.getLangValue("base.requireGroupAndindicator"),
                                            icon: "ri-error-warning-line",
                                            variant: "danger",
                                        });
                                        this.currentTab = 1
                                        break;
                                    }
                                    // 英文指标名称为空
                                    let arr1_en = indicatorList2.filter(item => item.name_en === '')
                                    // console.log(arr1);
                                    if (arr1_en.length) {
                                        checkRes = false;
                                        // console.log(111154);
                                        this.openAlert({
                                            content: this.getLangValue("base.requireGroupAndindicator"),
                                            icon: "ri-error-warning-line",
                                            variant: "danger",
                                        });
                                        this.currentTab = 2
                                        break;
                                    }
                                    // 验证是否适用  需要填写阈值  达标判断方式
                                    // let arr_2 = indicatorList2.filter(item => (category_name==3 && item.is_applicable == 1) && (item.threshold === '' || item.judgement_model === '' || item.judgement_model == null))
                                    let arr_2 = []
                                    if (arr_2.length) {
                                        checkRes = false;
                                        this.openAlert({
                                            content: this.getLangValue("base.needInfo"),
                                            icon: "ri-error-warning-line",
                                            variant: "danger",
                                        });
                                        break;
                                    }

                                    // 验证选择为介于数据 需要填写上下限值
                                    let arr_3 = indicatorList2.filter(item => item.judgement_model == '[]' && ((typeof item.threshold1=='undefined' || item.threshold1 ==='' || typeof item.threshold2=='undefined'  ||!item.threshold2 ==='') || (item.threshold1 >= item.threshold2)))
                                    if (arr_3.length) {
                                        checkRes = false;
                                        this.openAlert({
                                            content: this.getLangValue("hscode.threshold_range_error"),
                                            icon: "ri-error-warning-line",
                                            variant: "danger",
                                        });
                                        break;
                                    }
                                }

                            }
                        }
                    }
                }
            }
            return checkRes;
        },

        checkForm() {
            //校验表单
            //规则type必选 database必选  name必填
            //描述不能超过200 
            // 组名不能为空 组名不能重复 指标名不能为空  同组指标名不能重复
            this.isCheckForm = true;
            // ((!this.formData.type || this.formData.type[0] == '') && !this.formData.dataBase) 
            if (!this.formData.type.length || !this.formData.name || !this.formData.name_en || (this.requiredCode && !this.formData.code)) {
                this.openAlert({
                    content: this.getLangValue("base.requiredinformation"),
                    icon: "ri-error-warning-line",
                    variant: "danger",
                });
                return false;
            }
            // if (!this.checkNumber()) {
            //     this.openAlert({
            //         content: getLangValue("hscode.messageLength"),
            //         icon: "ri-error-warning-line",
            //         variant: "danger",
            //     });
            //     return false;
            // }
            if (this.formData.description.length > 500 || this.formData.description_en.length > 500) {
                this.openAlert({
                    content: getLangValue("hscode.descriptionLong"),
                    icon: "ri-error-warning-line",
                    variant: "danger",
                });
                return false;
            }
            // 验证第一级
            const checkFormLevel1_res = this.checkFormLevel1();
            if (!checkFormLevel1_res) {
                return false;
            }

            this.isCheckForm = false
            return true;
        },
        openAlert(info) {
            if (info) {
                this.alertInfo.content = info.content;
                this.alertInfo.icon = info.icon;
                this.alertInfo.variant = info.variant;
            }
            this.formValidataAlert = true;
            setTimeout(
                () => {
                    this.formValidataAlert = false;
                },
                5000
            );
        },
        checkFile(file) {
            let name = /^device\//.test(file.name)
                ? file.name.substring(44)
                : file.name;
            let suffix = name.substring(name.lastIndexOf(".")).toLowerCase();
            let type = /\.(png|jpeg|jpg)$/.test(suffix)
                ? "image"
                : /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
                    ? "document"
                    : "video";
            let i = this.fileListObj[type].findIndex((item) => {
                let filname = /^device\//.test(item.filname)
                    ? item.filname.substring(44)
                    : item.filname;
                return filname === name && item.type === type;
            });
            return i == -1;
        },
        selectedFile() {
            let dropzoneFile = document.querySelector(".dropzoneFile").files[0];
            if (!dropzoneFile) return;
            if (dropzoneFile.size > fileMaxSize) {
                this.openAlert(
                    {
                        variant: "danger",
                        content: getLangValue("upload.limit") + '50M',
                        icon: "ri-error-warning-line",
                    },
                    false
                );
                document.getElementById("dropzoneFile").value = "";
                return;
            }
            if (!this.checkFile(dropzoneFile)) {
                this.openAlert(
                    {
                        variant: "danger",
                        content: getLangValue("upload.notSameFile"),
                        icon: "ri-error-warning-line",
                    },
                    false
                );
                document.getElementById("dropzoneFile").value = "";
                return;
            }

            uploadFile(dropzoneFile)
                .then((res) => {
                    const { filename } = res.data.payload
                    let suffix = filename.substring(
                        filename.lastIndexOf(".")
                    ).toLowerCase();
                    if (/\.(png|jpeg|jpg)$/.test(suffix)) {
                        this.fileListObj.image.push(res.data.payload)
                    } else if (
                        /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
                    ) {
                        this.fileListObj.document.push(res.data.payload)
                    } else {
                        this.fileListObj.video.push(res.data.payload)
                    }
                    //清除上一张图片
                    document.getElementById("dropzoneFile").value = "";
                })
                .catch((e) => {
                    console.log(e);
                });

        },
        drop(e) {
            let dropzoneFile = e.dataTransfer.files[0];
            if (!dropzoneFile) return;
            // this.uploadFileSign(dropzoneFile);
        },
        deleteFile(...args) {
            // Swal.fire("删除成功!");
            // console.log(args);
            const [i, type] = args
            if (/\.(png|jpeg|jpg)$/.test(type)) {
                this.fileListObj['image'].splice(i, 1);
            } else if (
                /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(type)
            ) {
                this.fileListObj['document'].splice(i, 1);
            } else {
                this.fileListObj['video'].splice(i, 1);
            }

        },
        sortIndicatorList(arr) {
            /**排序 指标*/
            let arr1 = arr.filter(item => !item.canedit)
            let arr2 = arr.filter(item => item.canedit)
            // console.log(arr1, arr2);
            return [...arr1, ...arr2]
        },
        set_index_standards(index_standards1, type = 'edit') {
            this.groupInfoList = []
            for (const item in index_standards1) {
                const { group_name, group_name_en, index_standards, editable, children } = index_standards1[item]
                let group_info = {
                    canedit: type == 'add' ? false : editable,
                    category_name: '', // 新增指标类别
                    group_name: group_name, // 新增指标类别描述
                    group_name_en: group_name_en, // 新增指标类别描述
                    expand: true, // 默认展开
                    indicatorList: index_standards.map(item_indicator => {
                        let m = {
                            ...item_indicator
                        }
                        // 
                        m.canedit = m.hscode_id == this.$route.query.id ? true : false
                        // 回显阈值上下限
                        if (item_indicator.judgement_model == '[]' && item_indicator.threshold) {
                            let arr = JSON.parse(item_indicator.threshold)
                            m.threshold1 = arr[0] || 0
                            m.threshold2 = arr[1] || 0
                        }
                        m.add = false
                        m.is_applicable = m.is_applicable ? 1 : 0
                        m.is_specific = m.is_specific ? 1 : 0
                        return m
                    }), //指标
                    children: []
                }
                if (index_standards.length) {
                    group_info.category_name = index_standards[0].category_name
                }
                if (children.length) {
                    for (const item1 in children) {
                        const { group_name: group_name1, group_name_en: group_name_en1, index_standards: index_standards1, children: children1, editable } = children[item1]
                        let child_info = {
                            group_name: group_name1,
                            group_name_en: group_name_en1,
                            canedit: type == 'add' ? false : editable,
                            indicatorList: index_standards1.map(item_indicator => {
                                let m = {
                                    ...item_indicator
                                }
                                m.is_applicable = m.is_applicable ? 1 : 0
                                m.is_specific = m.is_specific ? 1 : 0
                                group_info.category_name = item_indicator.category_name
                                m.canedit = m.hscode_id == this.$route.query.id ? true : false
                                // 回显阈值上下限
                                if (item_indicator.judgement_model == '[]' && item_indicator.threshold) {
                                    let arr = JSON.parse(item_indicator.threshold)
                                    m.threshold1 = arr[0] || 0
                                    m.threshold2 = arr[1] || 0
                                }
                                m.add = false
                                return m
                            }),
                            children: []
                        }
                        if (index_standards1.length) {
                            group_info.category_name = index_standards1[0].category_name
                        }
                        if (children1.length) {
                            for (const item2 in children1) {
                                const { group_name: group_name2, group_name_en: group_name_en2, index_standards: index_standards2, editable } = children1[item2]
                                let child_info1 = {
                                    group_name: group_name2,
                                    group_name_en: group_name_en2,
                                    canedit: type == 'add' ? false : editable,
                                    indicatorList: index_standards2.map(item_indicator => {
                                        let m = {
                                            ...item_indicator
                                        }
                                        m.is_applicable = m.is_applicable ? 1 : 0
                                        m.is_specific = m.is_specific ? 1 : 0
                                        group_info.category_name = item_indicator.category_name
                                        m.canedit = m.hscode_id == this.$route.query.id ? true : false
                                        // 回显阈值上下限
                                        if (item_indicator.judgement_model == '[]' && item_indicator.threshold) {
                                            let arr = JSON.parse(item_indicator.threshold)
                                            m.threshold1 = arr[0] || 0
                                            m.threshold2 = arr[1] || 0
                                        }
                                        m.add = false
                                        return m
                                    }),
                                }
                                if (index_standards2.length) {
                                    group_info.category_name = index_standards2[0].category_name
                                }
                                child_info.children.push(child_info1)
                            }
                        }
                        group_info.children.push(child_info)
                        // console.log(child_info);
                    }
                }
                this.groupInfoList.push(group_info)
            }
            // 排序 把可以编辑的放在第一位
            // console.log(this.groupInfoList);
            if (type == 'edit')
                this.groupInfoList.sort((a, b) => b.canedit - a.canedit);
        },
        async getHscodeInfoByid(id) {
            //获取hscode详细信息
            this.loadingForm = true;
            const resp = await getHscodeDetail(id);
            if (resp) {
                // console.log(resp);
                const { title, title_en, description, description_en, index_standards, attachments, code, parent_id } = resp.payload;
                // this.formData.dataBase = database
                this.formData.name = title
                this.formData.name_en = title_en
                // console.log(this.formData.name);
                this.formData.description = description
                this.formData.description_en = description_en
                this.formData.code = code
                // 回显选中的国家  如果有的话
                // let arr = this.countryList.filter(item => item.key === destination_market)
                // if (arr.length > 0) {
                //     this.target_market = arr[0].key
                //     this.formData.target_market_code = destination_market
                // }
                // if (destination_market == '-') {
                //     this.target_market = ''
                //     this.formData.target_market_code = ''
                // } else {
                //     this.target_market = 'other'
                //     this.formData.target_market_code = destination_market
                // }


                // this.formData.type = !parent_id ? [""] : parent_id;
                // 回显父级信息
                if (parent_id) {
                    const res = getParentIds(this.typeList, parent_id)
                    this.formData.type = [...res, parent_id]
                    nextTick(() => {
                        this.changeType(1)
                    })

                } else {
                    this.formData.type = ['']
                    this.requiredCode = true
                }
                //回显指标信息
                if (index_standards) {
                    // console.log(111);
                    this.set_index_standards(index_standards, 'edit')
                    // for (let k in index_standards) {
                    //     // console.log(k);
                    //     let groupInfo = {
                    //         groupName: k,
                    //         indicatorList: [],
                    //         canedit: true,
                    //         category_name: '',
                    //     };
                    //     let indicatorList = index_standards[k];
                    //     if (indicatorList.length) {
                    //         indicatorList.forEach(item_indicator => {
                    //             item_indicator.canedit = item_indicator.hscode_id == this.$route.query.id ? true : false
                    //             item_indicator.add = false
                    //             // let indicatorInfo = {
                    //             //     name: item_indicator.name,
                    //             //     unit: item_indicator.unit,
                    //             //     value: item_indicator.value,
                    //             //     reference: item_indicator.reference,

                    //             // };
                    //             // groupInfo.indicatorList.push(indicatorInfo)
                    //         })
                    //         // 排序
                    //         indicatorList = this.sortIndicatorList(indicatorList)
                    //         groupInfo.category_name = indicatorList.length ? indicatorList[0].category_name : ''
                    //         // 有一个不能编辑的说明 包含父级信息 就不能修改组名 和分类
                    //         groupInfo.canedit = indicatorList.filter(item => !item.canedit).length ? false : true

                    //         groupInfo.indicatorList = indicatorList
                    //     }
                    //     this.groupInfoList.push(groupInfo)
                    // }
                }
                // 回显文件信息
                if (attachments && attachments.length) {
                    for (let k in attachments) {
                        //获取type
                        const { name: filename } = attachments[k]
                        attachments[k].filename = filename
                        let suffix = filename.substring(
                            filename.lastIndexOf(".")
                        ).toLowerCase();
                        if (/\.(png|jpeg|jpg)$/.test(suffix)) {
                            this.fileListObj.image.push(attachments[k])
                        } else if (
                            /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
                        ) {
                            this.fileListObj.document.push(attachments[k])
                        } else {
                            this.fileListObj.video.push(attachments[k])
                        }
                    }
                }
            }
            this.loadingForm = false;
        },
        setValue(childs, num) {
            /**
             * ? 限制可选最大层级 现在只能选到第4层
             */
            let children = _.cloneDeep(childs);
            children.forEach((child) => {
                child.num = num + 1;
                if (child.children && child.children.length && child.num <= 3) {
                    child.children = this.setValue(child.children, child.num);
                } else {
                    child.children = []
                }
            });
            return children;
        },
    },
    created() {
        this.getTypeList();
        // // 增加一个其他的国家
        // let arr = this.countryList.filter(item => item.key == 'other')
        // if (arr.length == 0)
        //     this.countryList.push({
        //         key: "other", en: "Other", zh: "其他"
        //     })
    },
    // watch:{
    //     currentTab:{
    //         Handler(newVal){
    //             console.log(newVal);
    //             this.props1.label = newVal ==2? 'title_en': 'title';
    //             console.log( this.props1);
    //         },
    //     },
    // },
};
</script>

<style lang="scss" scoped>
.el-input {
    height: 100%;
}

.is-invalid {
    border: 1px solid #f06548;
    border-radius: 4px;
    padding-right: 0 !important;
}

.nav-slide-item {
    border: unset !important;
}

.el-cascader-node {
    label {
        margin-bottom: unset !important;
    }
}

:deep(.el-cascader .el-input) {
    height: 100%;
}

:deep(.el-cascader.is-invalid) {
    border: 1px solid #f06548;
    border-radius: 4px;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-radio-group) {
    label {
        margin-bottom: 0;
    }
}

:deep(.el-radio-button__original-radio:checked+.el-radio-button__inner) {
    background-color: #0AB39C;
    border-color: #0AB39C;
}
</style>